if (!customElements.get('popup-toggle')) {
  class PopupToggle extends HTMLElement {
    constructor() {
      super();

      this.handleClickRef = this.handleClick.bind(this);
    }

    handleClick(event) {
      event.preventDefault();

      const anchor = event.target.closest('a');
      if (!anchor) return;

      document.dispatchEvent(new CustomEvent('rocket:popup-toggle', { detail: { target: anchor.getAttribute('href') } }));
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleClickRef);
    }

    connectedCallback() {
      this.addEventListener('click', this.handleClickRef);
    }
  }

  customElements.define('popup-toggle', PopupToggle);
}
